module.exports = __webpack_public_path__ + "img/album18_02.78b2ee21.jpg";